import { render, staticRenderFns } from "./Consume.vue?vue&type=template&id=51e787f1&scoped=true&"
import script from "./Consume.vue?vue&type=script&lang=js&"
export * from "./Consume.vue?vue&type=script&lang=js&"
import style0 from "./Consume.vue?vue&type=style&index=0&id=51e787f1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e787f1",
  null
  
)

export default component.exports